import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { observer, useLocalObservable } from 'mobx-react';
import React, { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useRootStore } from 'store/StoreContextProvider';

import { Button } from 'antd-mobile';
import M5APIs from 'm5/M5APIs';
import { toJS } from 'mobx';
import LoginByEmailPage from 'pages/LoginPage/LoginByEmailPage';
import useSnackbarMessage from 'shared/snackbar';
import EmployeeDetailPageStore from './store/EmployeeDetailPageStore';

const PluginOutlookPage = () => {
  const [loading, setLoading] = React.useState(false);
  const [alert, setAlert] = React.useState({
    open: false,
    severity: 'success',
    message: '',
    title: '',
  });

  const pageStore = useLocalObservable(() => new EmployeeDetailPageStore());
  const { loginStore } = useRootStore();
  const navigate = useNavigate();
  const location = useLocation();
  const snackbar = useSnackbarMessage();
  const openPath = location.pathname + '/open' + location.search;
  const closePath = location.pathname + '/close' + location.search;
  const loginPath = location.pathname + '/login' + location.search;
  const [searchParams, setSearchParams] = useSearchParams();

  const email = `${searchParams.get('email')}`;
  const fromEmail = `${searchParams.get('from')}`;
  let messageId = `${searchParams.get('messageId')}`;
  const conversationId = `${searchParams.get('conversationId')}`;

  const NO_DATA_ON_DB = '본 메일은 DB에 저장되어 있지 않습니다';
  const onOpenAdvice = async () => {
    let isAccessDone = false;
    if (location.state?.employee) {
      if (pageStore.taskList.length === 0) {
        if (pageStore.pubDoneList.length === 0) {
          if (pageStore.prvDoneList.length === 0) {
            snackbar.error(NO_DATA_ON_DB);
            return;
          } else {
            pageStore.taskList[0] = pageStore.prvDoneList[0];
          }
        } else {
          isAccessDone = true;
        }
      }

      const employee = location.state.employee;

      if (isAccessDone) {
        navigate(openPath, {
          state: {
            employee: toJS(employee),
            task: toJS(pageStore.pubDoneList[0]),
            assess: toJS(pageStore.pubAssessList[0]),
            isAssessDone: true,
          },
        });
      } else {
        navigate(openPath, {
          state: {
            employee: toJS(employee),
            task: toJS(pageStore.taskList[0]),
            isAssessDone: false,
          },
        });
      }
    } else {
      snackbar.error(`어드민에서 동료와 부하직원 리스트를 설정해주세요: ${fromEmail}`);
      return;
    }
  };

  const onCloseAssess = async () => {
    if (location.state?.employee) {
      let isAccessDone = false;
      if (pageStore.taskList.length === 0) {
        if (pageStore.prvDoneList.length === 0) {
          if (pageStore.pubDoneList.length === 0) {
            snackbar.error(NO_DATA_ON_DB);
            return;
          } else {
            pageStore.taskList[0] = pageStore.pubDoneList[0];
          }
        } else {
          isAccessDone = true;
        }
      }

      const employee = location.state.employee;

      if (isAccessDone) {
        navigate(closePath, {
          state: {
            employee: toJS(employee),
            task: toJS(pageStore.prvDoneList[0]),
            assess: toJS(pageStore.prvAssessList[0]),
            isAssessDone: true,
          },
        });
      } else {
        navigate(closePath, {
          state: {
            employee: toJS(employee),
            task: toJS(pageStore.taskList[0]),
            isAssessDone: false,
          },
        });
      }
    } else {
      snackbar.error(`어드민에서 동료와 팀원 리스트를 설정해주세요: ${fromEmail}`);
      return;
    }
  };

  const onLogout = async () => {
    loginStore.onLogout();
    navigate(loginPath, {
      state: {
        prevPath: location.pathname,
      },
    });
    snackbar.success('로그아웃되었습니다.');
  };

  useEffect(() => {
    if (loginStore.currentUser) {
      console.log('#######', location.state?.employee);
      if (location.state?.employee) {
        const employee = location.state.employee;
        pageStore.setEmployee(employee);
        fetchTaskItem();
      } else {
        if (location.state?.employee === '') {
          snackbar.error(`어드민에서 동료와 팀원 리스트를 설정해주세요: ${fromEmail}`);
        } else {
          const nextUrl = '/plugin/mails/login' + location.search;
          navigate(nextUrl);
        }
      }
      // console.log(pageStore.employee);
    } else {
      const nextUrl = '/plugin/mails/login' + location.search;
      navigate(nextUrl);
    }
  }, [loginStore.currentUser]);

  const fetchTaskItem = async () => {
    try {
      pageStore.setLoading(true);
      const res = await pageStore.fetchTaskByEmailMessageId(loginStore.currentUser, messageId.replaceAll('/', '-').replaceAll('+', '_').replaceAll(' ', '_'));
      if (res?.expired) {
        loginStore.onLogout();
        pageStore.setLoading(false);
        return;
      }
      if (res.total === 0) {
        const userId = loginStore.currentUser?.userData.graphId ?? '';
        try {

          const response = await M5APIs.convertId(userId, messageId);

          if (response != null) {
            messageId = response[0].targetId;
            console.log(messageId);
            const res = await pageStore.fetchTaskByEmailMessageId(loginStore.currentUser, messageId.replaceAll('/', '-').replaceAll('+', '_').replaceAll(' ', '_'));
            if (res?.expired) {
              loginStore.onLogout();
              pageStore.setLoading(false);
              return;
            }
            if (res.total === 0) {
              snackbar.error(`평가할 수 없는 이메일입니다. 관리자에게 문의하시기 바랍니다.${response[0].targetId}`);
            }

          }

        } catch (err: any) {
          pageStore.setLoading(false);
          snackbar.error(`ID에러 ${userId} ${messageId}`);
        }
        pageStore.setLoading(false);
        return;
      }
    } catch (err: any) {
      pageStore.setLoading(false);
      snackbar.error(err.message);
    }
    pageStore.setLoading(false);
  };

  /************************************************************************
   * Render
   ************************************************************************/

  return (
    <>
      {(!loginStore.currentUser || pageStore.isReady === false || pageStore.isLoading === true) ? (
        <Grid container justifyContent={'center'} style={{ marginTop: '150px' }}>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <CircularProgress />

            <div style={{ marginTop: 50 }}>
              Loading PAS for Jeisian...
            </div>
          </Stack>
        </Grid>
      ) :
        (
          <Box sx={{ width: '100%', overflowY: 'hidden' }} display='flex' justifyContent='center' alignItems='center' minHeight='70vh'>
            <Grid container xs={10} md={10}>
              <Grid xs={12} md={12} mdOffset={0}>
                <Grid container>
                  <Grid xs={5} >
                    <Typography style={{ fontWeight: 700, fontSize: '18px', lineHeight: '16px' }}>PAS for Jeisian</Typography>
                  </Grid>
                  <Grid xs={2} ><Typography style={{ fontWeight: 500, fontSize: '10px', marginLeft: 10 }} > v1.1.1</Typography></Grid>
                </Grid>




                <Typography style={{ fontWeight: 500, fontSize: '12px', lineHeight: '16px', color: '#888888', marginBottom: '50px', marginTop: 3 }}>상시 조언을 통한 업무역량 향상.</Typography>
              </Grid>
              <Grid xs={12} md={10} mdOffset={2}>
                <Button block type='submit' color='primary' size='large' loading={loading} onClick={onOpenAdvice}>
                  <b>Advice</b> in Public
                </Button>
                <Typography style={{ fontWeight: 500, fontSize: '12px', lineHeight: '16px', color: '#888888', marginTop: 3 }}>[공개 조언] 진솔한 조언을 보내주세요</Typography>
              </Grid>
              <Grid xs={12} md={10} mdOffset={2} style={{ marginTop: '70px' }}>
                <Button block type='button' color='primary' size='large' loading={loading} onClick={onCloseAssess}>
                  <b>Appraisal</b> in Private
                </Button>
                <Typography style={{ fontWeight: 500, fontSize: '12px', lineHeight: '16px', color: '#888888', marginTop: 3 }}>[비공개 평가] 혼자만의 기록을 남기세요</Typography>
              </Grid>
            </Grid>
          </Box >
        )}
      {!loginStore.currentUser && <LoginByEmailPage />}
    </>
  );
};

export default observer(PluginOutlookPage);
